/* script */
//
//
//
//
//
//
//
//
//
//
//

// Components
import TemplateDetails from 'ui/components/TemplateDetails.vue';

// Mixins
import workspaceCard from 'ui/mixins/cards/workspace-card';

/**
 * This component renders an template card.
 *
 * @category ui.components.cards
 * @exports WorkspaceTemplate
 */
const __vue_script__ = {
    name: 'WorkspaceTemplate',

    mixins: [workspaceCard],

    data() {
        return {
            img: this.$services.template.getAppIconUrl(this.workspace),
            subtitle: this.workspace.template_description
        };
    },

    methods: {
        /**
         * The action to execute when clicking on badge (open the show details modal)
         *
         * @param {Object} template The Template object
         */
        templateDetails() {
            this.$modal.show(TemplateDetails,
                {
                    templateId: this.workspace.id,
                },
                {
                    classes: 'medium',
                    height: 'auto',
                    reset: true
                }
            );
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card", {
    staticClass: "workspace-card hovering",
    attrs: {
      link: _vm.link,
      "media-bg": _vm.img,
      uid: _vm.uid,
      selected: _vm.selected,
      selectable: _vm.selectable,
    },
    on: {
      click: function ($event) {
        return _vm.$emit("click", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "badges",
        fn: function (ref) {
          return [
            _c("event-badge", {
              staticClass: "visibility",
              attrs: { event: _vm.workspace, mode: "visibility" },
            }),
            _c(
              "button",
              {
                staticClass: "details btn primary mini",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.templateDetails()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("templates.view_details")))]
            ),
          ]
        },
      },
      {
        key: "content",
        fn: function (ref) {
          return [
            _vm.workspace.org
              ? _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.bottom",
                        value: _vm.getTooltipConfig(
                          _vm.workspace.orgDisplayName
                        ),
                        expression:
                          "getTooltipConfig(workspace.orgDisplayName)",
                        modifiers: { bottom: true },
                      },
                    ],
                    staticClass: "sup",
                  },
                  [_vm._v(_vm._s(_vm.workspace.orgDisplayName))]
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.getTooltipConfig(_vm.title),
                    expression: "getTooltipConfig(title)",
                  },
                ],
                staticClass: "title",
              },
              [_vm._v(_vm._s(_vm.title))]
            ),
            _c(
              "small",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.getTooltipConfig(_vm.subtitle),
                    expression: "getTooltipConfig(subtitle)",
                  },
                ],
                staticClass: "sub",
              },
              [_vm._v(_vm._s(_vm.subtitle))]
            ),
          ]
        },
      },
    ]),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/cards/WorkspaceTemplate.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__